<template>
  <main class="supplier-page">
    <section class="soft-card table-panel">
      <div class="toolbar">
        <el-input
          v-model="searchQuery"
          placeholder="搜索供应商..."
          size="small"
          clearable
          class="search-input"
          @keyup.enter.native="onSearch" @clear="onSearch"
        />
        <el-button size="small" plain icon="el-icon-search" @click="onSearch">搜索</el-button>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="onAdd">新增</el-button>
      </div>

      <!-- Desktop table -->
      <div class="desktop-only">
        <el-table :data="suppliers" size="small" style="width: 100%">
          <el-table-column type="index" label="序号" width="70" :index="pageIndex" />
          <el-table-column prop="code" label="编码" width="120" />
          <el-table-column prop="name" label="供应商名称" min-width="160" />
          <el-table-column prop="apiUrl" label="API 地址" min-width="280" show-overflow-tooltip>
            <template slot-scope="scope">
              <code class="api-url-text">{{ scope.row.apiUrl }}</code>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="180">
            <template slot-scope="scope">{{ $formatTime(scope.row.createdAt) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="onApiKeyManage(scope.row)">API Key</el-button>
              <el-button size="small" type="text" @click="onModelMaintain(scope.row)">模型维护</el-button>
              <el-button size="small" type="text" @click="onEdit(scope.row)">编辑</el-button>
              <el-button size="small" type="text" class="delete-btn" @click="onDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- Mobile card list -->
      <div class="mobile-only list-cards">
        <div v-for="(row, i) in suppliers" :key="i" class="list-card">
          <div class="card-header">
            <div>
              <div class="card-title">{{ row.name }}</div>
              <div class="card-sub">{{ row.code }}</div>
            </div>
          </div>
          <div style="margin-bottom:10px;font-size:12px;color:rgba(255,255,255,.6);word-break:break-all;">
            <code style="font-size:11px;color:#8eddf8;background:rgba(50,200,245,.08);padding:1px 6px;border-radius:4px;">{{ row.apiUrl }}</code>
          </div>
          <div class="meta-row">
            <span>创建于 {{ $formatTime(row.createdAt) }}</span>
          </div>
          <div class="card-actions">
            <el-button size="small" type="text" @click="onApiKeyManage(row)">API Key</el-button>
            <el-button size="small" type="text" @click="onModelMaintain(row)">模型维护</el-button>
            <el-button size="small" type="text" @click="onEdit(row)">编辑</el-button>
            <el-button size="small" type="text" class="delete-btn" @click="onDelete(row)">删除</el-button>
          </div>
        </div>
      </div>

      <el-pagination
        class="pagination-bar"
        layout="total, prev, pager, next"
        small
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="onPageChange"
      />
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="520px" :close-on-click-modal="false">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px" label-position="right" size="small">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="编码" prop="code">
                <el-input v-model="form.code" placeholder="例: CMCC" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input v-model="form.name" placeholder="例: 中国移动" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="API 地址" prop="apiUrl">
            <el-input v-model="form.apiUrl" placeholder="https://api.example.com/v1" clearable />
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogVisible = false" size="small">取消</el-button>
          <el-button type="primary" @click="submitForm" size="small" :loading="submitting">确定</el-button>
        </span>
      </el-dialog>
    </section>
  </main>
</template>

<script>
export default {
  name: 'SupplierPage',
  data() {
    return {
      suppliers: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      searchQuery: '',
      dialogVisible: false,
      dialogTitle: '',
      rules: {
        code: [
          { required: true, message: '请输入编码', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9_-]+$/, message: '仅支持字母、数字、下划线和短横线', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        apiUrl: [
          { pattern: /^https?:\/\/.+/, message: '请输入有效的 API 地址（需以 http:// 或 https:// 开头）', trigger: 'blur' }
        ]
      },
      submitting: false,
      form: {
        id: null,
        code: '',
        name: '',
        apiUrl: ''
      }
    }
  },
  computed: {
    pageIndex() {
      return (this.currentPage - 1) * this.pageSize + 1
    }
  },
  mounted() {
    this.fetchSuppliers()
  },
  methods: {
    async fetchSuppliers() {
      try {
        const res = await this.$http.get('/admin/suppliers', {
          params: {
            keyword: this.searchQuery || undefined,
            page: this.currentPage,
            pageSize: this.pageSize
          }
        })
        this.suppliers = res.records || []
        this.total = Number(res.total) || 0
      } catch {
        this.$message.error('加载供应商列表失败')
      }
    },
    onPageChange(page) {
      this.currentPage = page
      this.fetchSuppliers()
    },
    onSearch() {
      this.currentPage = 1
      this.fetchSuppliers()
    },
    onAdd() {
      this.dialogTitle = '新增供应商'
      this.form = { id: null, code: '', name: '', apiUrl: '' }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form?.clearValidate())
    },
    onEdit(row) {
      this.dialogTitle = '编辑供应商'
      this.form = { id: row.id, code: row.code, name: row.name, apiUrl: row.apiUrl || '' }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form?.clearValidate())
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          if (this.form.id) {
            await this.$http.put('/admin/suppliers/' + this.form.id, this.form)
            this.$message.success('编辑成功')
          } else {
            await this.$http.post('/admin/suppliers', this.form)
            this.$message.success('新增成功')
          }
          this.dialogVisible = false
          this.fetchSuppliers()
        } catch {
          this.$message.error('操作失败')
        } finally {
          this.submitting = false
        }
      })
    },
    onModelMaintain(row) {
      this.$router.push('/supplier-models/' + row.id + '?code=' + row.code + '&name=' + encodeURIComponent(row.name))
    },
    onApiKeyManage(row) {
      this.$router.push('/supplier-api-keys/' + row.id + '?code=' + row.code + '&name=' + encodeURIComponent(row.name))
    },
    onDelete(row) {
      this.$confirm('确定删除供应商「' + row.name + '」？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return this.$http.delete('/admin/suppliers/' + row.id)
      }).then(() => {
        this.$message.success('删除成功')
        this.fetchSuppliers()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.supplier-page {
  padding: 18px 24px 76px;
}

.table-panel {
  padding: 16px;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.table-panel ::v-deep .el-table,
.table-panel ::v-deep .el-table__header-wrapper,
.table-panel ::v-deep .el-table__body-wrapper {
  border-radius: var(--radius);
}

.table-panel ::v-deep th {
  background: rgba(255, 255, 255, 0.045);
  color: #9eb1ca;
  font-weight: 850;
}

.table-panel ::v-deep td,
.table-panel ::v-deep th {
  border-color: var(--line-soft);
}

.pagination-bar {
  margin-top: 20px;
  text-align: right;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
}

.search-input {
  width: 200px;
}

.delete-btn {
  color: #ff93a4;
}

.delete-btn:hover {
  color: #ffb6c1;
}

.api-url-text {
  display: block;
  font-size: 13px;
  color: #8eddf8;
  background: rgba(50, 200, 245, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---------- Mobile card list ---------- */
.list-cards {
  display: grid;
  gap: 14px;
}

/* ---------- Responsive helpers ---------- */
.mobile-only { display: none; }

@media (max-width: 760px) {
  .desktop-only { display: none; }
  .mobile-only { display: block; }
  .supplier-page {
    padding: 12px 12px 28px;
  }
  .table-panel {
    padding: 10px;
    overflow-x: visible;
  }
  .toolbar {
    flex-wrap: wrap;
  }
  .search-input {
    flex: 1;
    min-width: 80px;
  }
  .pagination-bar {
    text-align: center;
  }
}
.list-card {
  padding: 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(27,39,58,.92), rgba(20,30,46,.88));
  border: 1px solid rgba(133,164,255,.12);
  box-shadow: 0 8px 28px rgba(0,0,0,.22);
  overflow: hidden;
  transition: transform .18s ease, box-shadow .18s ease;
}
.list-card:active {
  transform: translateY(-1px);
  box-shadow: 0 12px 36px rgba(0,0,0,.3);
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 8px;
}
.card-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text);
  line-height: 1.3;
}
.card-sub {
  font-size: 12px;
  color: rgba(255,255,255,.4);
  margin-top: 2px;
}
.stats-row {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
.stat-item {
  flex: 1;
  min-width: 0;
  background: rgba(255,255,255,.04);
  border-radius: 8px;
  padding: 8px 10px;
  text-align: center;
}
.stat-value {
  font-size: 14px;
  font-weight: 700;
  color: var(--text);
  line-height: 1.3;
}
.stat-label {
  font-size: 10px;
  color: rgba(255,255,255,.35);
  margin-top: 2px;
  letter-spacing: .02em;
}
.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(133,164,255,0.06);
  margin-top: 6px;
  font-size: 11px;
  color: rgba(255,255,255,.35);
}
.card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-top: 10px;
  border-top: 1px solid rgba(133,164,255,0.06);
  margin-top: 6px;
}
.card-actions .el-button--text {
  font-size: 12px;
  padding: 4px 10px;
  height: auto;
}
</style>
